import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Events, AlertController } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { QrHelperProvider } from '../../providers/qr-helper/qr-helper';
import { ToastHelperProvider } from '../../providers/toast-helper/toast-helper';

import { StatusDetailPage } from '../status-detail/status-detail'

/**
 * Generated class for the StatusPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-status',
  templateUrl: 'status.html',
})
export class StatusPage {
  private scanSub: any ;
  public isScanning: boolean = false;
  public loading;
  public errorMessage;
  public scanEventName = 'statusLotCode:scanned';
  public _scanEventFunction;
  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private toastHelper: ToastHelperProvider,
              public loadingCtrl: LoadingController,
              private rest: RestProvider,
              private qrHelper: QrHelperProvider,
              public events: Events,
              public alertCtrl: AlertController) {
  }

  ionViewWillEnter(){
    this._scanEventFunction = text => {this.codeFound(text);}
    this.events.subscribe(this.scanEventName, this._scanEventFunction);
  }

  ionViewWillLeave(){
    this.qrHelper.destroyQr();
    this.events.unsubscribe(this.scanEventName, this._scanEventFunction);
  }

  startScan(){
    this.qrHelper.startQr(this.scanEventName, 'qr-reader-status');
  }

  stopScan(){
  	this.qrHelper.destroyQr();
  }

  codeFound(text:string) {
    let qrObj = JSON.parse(text);
    if (typeof(qrObj) === 'object' && 'section' in qrObj) {
      if(qrObj['section'] == 'lots'){
        if ('entryId' in qrObj) {
          this.navCtrl.push(StatusDetailPage, {
            lotId: qrObj.entryId
          });
        }else{
          this.toastHelper.showToast('ERROR: Fout bij het lezen van de QR code.', 'error');
        }
      }else{
        this.toastHelper.showToast('ERROR: QR code is niet van een lot maar van: ' + qrObj['section'] + '.', 'error');
      }
    }else{
       this.toastHelper.showToast('ERROR: Onbekende QR code.', 'error');
    }
  }

  presentNoConnectionAlert(retryCb, retryParams = null, cancelCb = null){
    let alert = this.alertCtrl.create({
      title: 'Geen internet',
      message: 'Kon geen verbinding maken',
      buttons: [
        {
          text: 'Annuleer',
          role: 'cancel',
          handler: () => {
            this.toastHelper.showToast('ERROR: Geen internetverbinding gevonden.', 'error');
            if (cancelCb != null) {
              cancelCb();
            }
            this.loading.dismiss();
          }
        },
        {
          text: 'Probeer opnieuw',
          handler: () => {
            if (retryParams != null) {
              retryCb(retryParams);
            }else{
              retryCb();
            }
          }
        }
      ]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/status/status.ts